<template>
  <div>
    <Layout/>
    <h4>Atención: Interconsulta</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idInterconsulta" class="form-label">IdInterconsulta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idInterconsulta" name="idInterconsulta" v-model="datoInterconsulta.idInterconsulta" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idAtencion" name="idAtencion" v-model="datoInterconsulta.idAtencion"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label"> Atencion</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="atencion" name="atencion" v-model="datoInterconsulta.atencion" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalAtencionLOV"
                      title="Buscar Diagnósticos">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idMedico" name="idMedico" v-model="datoInterconsulta.idMedico"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idMedico" class="form-label"> Medico</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="medico" name="medico" v-model="datoInterconsulta.medico" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalMedicoLOV"
                      title="Buscar Médico">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="cuadro" class="form-label">Cuadro</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="cuadro" name="cuadro" v-model="datoInterconsulta.cuadro" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="resumen" class="form-label">Resumen</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="resumen" name="resumen" v-model="datoInterconsulta.resumen" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarInterconsulta" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarInterconsulta" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditInterconsulta" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdPlanDiag</th>
          <th scope="col">IdDiagnostico</th>
          <th scope="col">IdInterconsulta</th>
          <th scope="col">Tipo</th>
          <th scope="col">Observación</th>
          <th scope="col">Estado</th>
          <th scope="col">DiagnosticoNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="plandiag in datosPaginados" :key="plandiag.idPlanDiag">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(plandiag.idPlanDiag)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(plandiag.idPlanDiag)" title="Editar">edit_square</i></td>
          <td>{{plandiag.idPlanDiag}}</td>
          <td>{{plandiag.idDiagnostico}}</td>
          <td>{{plandiag.idInterconsulta}}</td>
          <td>{{plandiag.tipo}}</td>
          <td>{{plandiag.observacion}}</td>
          <td>{{plandiag.estado}}</td>
          <td>{{plandiag.diagnosticoNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteInterconsulta(plandiag.idPlanDiag)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idPlanDiag" class="form-label">IdPlanDiag</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPlanDiag" name="idPlanDiag" v-model="datoPlanDiag.idPlanDiag" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idDiagnostico" name="idDiagnostico" v-model="datoPlanDiag.idDiagnostico"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idDiagnostico" class="form-label"> Diagnostico</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="diagnostico" name="diagnostico" v-model="datoPlanDiag.diagnostico" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalDiagnosticoLOV"
                      title="Buscar Diagnóstico">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idInterconsulta" class="form-label">IdInterconsulta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idInterconsulta" name="idInterconsulta" v-model="datoPlanDiag.idInterconsulta" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoPlanDiag.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoPlanDiag.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarPlanDiag" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPlanDiag" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!-- Lista de Valores: Atencion -->
    <AtencionLOV @DatosAtencion="GetDataAtencionLOV($event)"/>
<!-- Lista de Valores: Medico -->
    <MedicoLOV @DatosMedico="GetDataMedicoLOV($event)"/>
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: PlanDiag -->
    <PlanDiagLOVdet @DatosPlanDiag="GetDataPlanDiagLOVdet($event)"/>
<!-- Lista de Valores: Diagnostico -->
    <DiagnosticoLOVdet @DatosDiagnostico="GetDataDiagnosticoLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';
// Listas de valores master
import AtencionLOV from '../../components/lovs/AtencionLOV.vue'
import MedicoLOV from '../../components/lovs/MedicoLOV.vue'
// Listas de valores master
// Listas de valores details
import PlanDiagLOVdet from '../../components/lovs/PlanDiagLOV.vue'
import DiagnosticoLOVdet from '../../components/lovs/DiagnosticoLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
, AtencionLOV
, MedicoLOV
// Listas de valores master
// Listas de valores details
, PlanDiagLOVdet
, DiagnosticoLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      interconsultas : [],
      datoInterconsulta : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idInterconsulta: '',
// Variables master
// Variables details
      plandiags : [],
      datoPlanDiag : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idInterconsulta = this.$route.params.p_idinterconsulta
    this.abrirEditar(this.p_idInterconsulta)
    this.getPlanDiags()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      if(this.datoInterconsulta.idInterconsulta === ''){
        swal("Error!", "El elemento idInterconsulta no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoInterconsulta.idAtencion === ''){
        swal("Error!", "El elemento idAtencion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoInterconsulta.idMedico === ''){
        swal("Error!", "El elemento idMedico no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoInterconsulta.cuadro === ''){
        swal("Error!", "El elemento cuadro no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoInterconsulta.resumen === ''){
        swal("Error!", "El elemento resumen no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoInterconsulta.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarInterconsulta(){
      if(this.validarForm() === 1){
        try {
          await api.post('/interconsultas', this.datoInterconsulta)
          swal("Correcto!", "Interconsulta creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditInterconsulta(){
      if(this.validarForm() === 1){
        try {
          await api.post('/interconsultas', this.datoInterconsulta)
          swal("Correcto!", "Interconsulta creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoInterconsulta={}
      this.titulo   = 'Crear Atención: Interconsulta'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idInterconsulta){
      this.modalWindow = true
      if(idInterconsulta != null){    
           api.get('/vwinterconsultas/'+idInterconsulta).then(resp=>{
          this.datoInterconsulta = resp.data;
           });
      }
      this.titulo   = 'Editar Atención: Interconsulta'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarInterconsulta(){
      this.$router.push('/Interconsulta')
    },
// Procedimientos master
// Procedimientos detalle
    async getPlanDiags() {
      const resp = await api.get('/plandiags')
      this.plandiags = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.plandiags.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwplandiags/nombre/'+this.nombreBusqueda).then(response=>{
          this.plandiags=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.plandiags.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwplandiags').then(response=>{
      this.plandiags=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.plandiags.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoPlanDiag.idInterconsulta === ''){
        swal("Error!", "El elemento idInterconsulta no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlanDiag.idAtencion === ''){
        swal("Error!", "El elemento idAtencion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlanDiag.idMedico === ''){
        swal("Error!", "El elemento idMedico no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlanDiag.cuadro === ''){
        swal("Error!", "El elemento cuadro no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlanDiag.resumen === ''){
        swal("Error!", "El elemento resumen no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlanDiag.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarPlanDiag(){
      if(this.validarForm() === 1){
        try {
          this.datoPlanDiag.idInterconsulta = this.datoInterconsulta.idInterconsulta;
          await api.post('/plandiags', this.datoPlanDiag)
          this.getPlanDiags();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "PlanDiag creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPlanDiag(){
      if(this.validarForm() === 1){
        try {
          await api.post('/plandiags', this.datoPlanDiag)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "PlanDiag creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoPlanDiag={}
      this.titulo   = 'Crear Atención: Interconsulta'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idPlanDiag){
      this.modalWindow = true
      if(idPlanDiag != null){    
           api.get('/vwplandiags/'+idPlanDiag).then(resp=>{
          this.datoPlanDiag = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Atención: Interconsulta'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idPlanDiag){
      this.modalWindow = true
      if(idPlanDiag != null){
        this.$router.push('/plandiagmd/'+idPlanDiag)
      }
    },
    async deletePlanDiag (idPlanDiag) {
      try{
        await api.delete('/plandiags/'+idPlanDiag)
          this.getPlanDiags()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
//    Lista de Valores
    GetDataAtencionLOV(data) {
      this.datoInterconsulta.idAtencion = data.idAtencion;
      this.datoInterconsulta.atencion = data.nombre;
    },
//    Lista de Valores
    GetDataMedicoLOV(data) {
      this.datoInterconsulta.idMedico = data.idMedico;
      this.datoInterconsulta.medico = data.nombre;
    },
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataPlanDiagLOVdet(data) {
      this.datoPlanDiag.idPlanDiag = data.idPlanDiag;
      this.datoPlanDiag.planDiag = data.nombre;
    },
//    Lista de Valores
    GetDataDiagnosticoLOVdet(data) {
      this.datoPlanDiag.idDiagnostico = data.idDiagnostico;
      this.datoPlanDiag.diagnostico = data.nombre;
    },
// Listas de valores details
  },
}
</script>
